export { default } from "./ChangePassword"


// WEBPACK FOOTER //
// ./src/mutations/ChangePassword/index.ts